import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var PaperAirplaneIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M2 15.257c0-.457.34-.8.679-.914l10.297-1.829c.453-.114.453-.685 0-.914L2.679 9.886C2.339 9.77 2 9.429 2 8.97V2.914C2 2.343 2.34 2 2.905 2h2.603c.113 0 .34 0 .452.114l15.616 9.143a.863.863 0 010 1.486L5.96 21.886C5.847 22 5.734 22 5.508 22H2.905A.897.897 0 012 21.086v-5.829z"
                    })
                })
            })
        ]
    });
};
PaperAirplaneIcon.isCarinaIcon = true;
export default PaperAirplaneIcon;
